module.exports = __webpack_public_path__ + "static/media/icon_cancel.24a192f6.svg";